import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { withTranslation } from "react-i18next";
import withRouter from "../../../../../components/Common/withRouter";

const DisableConfirmationModal = ({
  isOpen,
  toggle,
  onConfirm,
  isDisabling,
  deductionToDisable,
  bonusToDisable,
  type = "bonus",
  t // t vient de withTranslation
}) => {
  const itemToDisable = type === "bonus" ? bonusToDisable : deductionToDisable;

  if (!itemToDisable) return null;

  // Adapter à la structure réelle des données
  const itemName = type === "bonus"
    ? itemToDisable.bonusName || itemToDisable.bonus?.name || itemToDisable.bonus?.label
    : itemToDisable.deduction?.name;

  const confirmText = type === "bonus"
    ? t("are_you_sure_disable_bonus")
    : t("are_you_sure_disable"); 

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        <i className="fa fa-ban text-warning me-2"></i>
        {t("confirm_disable")} 
      </ModalHeader>
      
      <ModalBody>
        <p className="mb-0">
          {confirmText} <strong className="text-warning">{itemName}</strong> ?
        </p>
        <small className="text-muted">
          {type === "bonus"
            ? t("bonus_will_be_disabled")
            : t("deduction_will_be_disabled")
          }
        </small>
      </ModalBody>
      
      <ModalFooter>
        <Button
          color="warning"
          onClick={() => onConfirm(itemToDisable)}
          disabled={isDisabling}
          className="me-2"
        >
          {isDisabling ? (
            <>
              <i className="fa fa-spinner fa-spin me-2"></i>
              {t("disabling")}...
            </>
          ) : (
            <>
              <i className="fa fa-ban me-2"></i>
              {t("disable")} 
            </>
          )}
        </Button>
        <Button color="secondary" onClick={toggle} disabled={isDisabling}>
          <i className="fa fa-times me-2"></i>
          {t("cancel")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default withRouter(withTranslation()(DisableConfirmationModal));